import { ACTION_CREATE, ACTION_EDIT, ACTION_DELETE, ACTION_VIEW } from '../../request';
import { Voter } from '../voter';

export class PageTemplatesVoter extends Voter {
    supports(request) {
        return request.resource === 'page-templates';
    }

    vote(request) {
        if (request.includes(ACTION_CREATE) && !this.canCreate(request)) {
            return false;
        }

        if (request.includes(ACTION_EDIT) && !this.canEdit(request)) {
            return false;
        }

        if (request.includes(ACTION_DELETE) && !this.canDelete(request)) {
            return false;
        }

        if (request.includes(ACTION_VIEW) && !this.canView(request)) {
            return false;
        }

        return true;
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canCreate(request) {
        const count = request.workspace.quantities.templates || 0;

        switch (request.role) {
            case 'unlimited':
                return count < 20;

            default:
                return false;
        }
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canDelete(request) {
        return this.canEdit(request);
    }

    canEdit(request) {
        if (!request.subject?._id) {
            return true;
        }

        return request.isBy(request.subject.author);
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canView(request) {
        if (!request.subject?._id || request.subject.public) {
            return true;
        }

        return request.isBy(request.subject.author);
    }
}
